import type { UseAccountReturnType } from "wagmi";
import { useAccount as useWagmiAccount } from "wagmi";

import config from "configs/app";
import useSafeApps from "lib/hooks/useSafeApps";

function useAccountFallback(): UseAccountReturnType {
  return {
    address: undefined,
    addresses: undefined,
    chain: undefined,
    chainId: undefined,
    connector: undefined,
    isConnected: false,
    isConnecting: false,
    isDisconnected: true,
    isReconnecting: false,
    status: "disconnected",
  };
}

function useAccountWithSafe(): UseAccountReturnType {
  const account = useWagmiAccount();
  const { safeInfo, isSafeApp } = useSafeApps();

  if (!isSafeApp || !safeInfo?.safeAddress) {
    return account;
  }

  const safeAddress = safeInfo.safeAddress as `0x${string}`;
  const isConnected = Boolean(safeAddress);

  return {
    ...account,
    address: safeAddress,
    addresses: [safeAddress],
    chainId: safeInfo.chainId ?? account.chainId,
    isConnected,
    isDisconnected: !isConnected,
    status: isConnected ? "connected" : account.status,
  } as UseAccountReturnType;
}

const hook = config.features.blockchainInteraction.isEnabled
  ? useAccountWithSafe
  : useAccountFallback;

export default hook;
